(function(){
  if((document.documentElement.lang||'').slice(0,2)!=='de')return;
  var SEL=[
    ['.footer-block__heading',{'Read':'Lesen & Infos','Free routines, new guides and offers – straight to your inbox.':'Gratis-Routinen, neue Guides und Angebote – direkt in dein Postfach.'}],
    ['.related-products__heading',{'You may also like':'Das könnte dir auch gefallen'}],
    ['.product-disclosures h2, .disclosures h2, h2',{'Product information':'Produktinformationen'}],
    ['.share-button__button',{'Share':'Teilen'}],
    ['.contact h2, .contact h1, h1, h2',{"Questions? We're here to help.":'Fragen? Wir helfen dir gern.','Questions? We’re here to help.':'Fragen? Wir helfen dir gern.'}],
    ['.collection-list-title, h1.title',{'Collections':'Kollektionen'}]
  ];
  function swapText(el,map){
    for(var n=el.firstChild;n;n=n.nextSibling){
      if(n.nodeType===3){var t=n.nodeValue.trim();if(map[t]){n.nodeValue=n.nodeValue.replace(t,map[t]);}}
    }
  }
  function run(){
    SEL.forEach(function(s){document.querySelectorAll(s[0]).forEach(function(el){swapText(el,s[1]);});});
  }
  function jdgm(root){
    var w=document.createTreeWalker(root||document.body,NodeFilter.SHOW_TEXT,null);var n;
    while((n=w.nextNode())){
      if(!n.parentElement||!n.parentElement.closest('[class*="jdgm"]'))continue;
      var v=n.nodeValue,o=v;
      v=v.replace(/out of 5/g,'von 5').replace(/based on (\d+) reviews?/gi,function(m,a){return 'aus '+a+(a==='1'?' Bewertung':' Bewertungen');})
         .replace(/^\s*(\d+) reviews?\s*$/i,function(m,a){return a+(a==='1'?' Bewertung':' Bewertungen');})
         .replace(/Be the first to write a review/i,'Schreib die erste Bewertung').replace(/Write a review/i,'Bewertung schreiben').replace(/Customer Reviews/i,'Kundenbewertungen');
      if(v!==o)n.nodeValue=v;
    }
  }
  function all(){run();jdgm();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  try{var mo=new MutationObserver(function(){jdgm();});mo.observe(document.documentElement,{childList:true,subtree:true});setTimeout(function(){mo.disconnect();},8000);}catch(e){}
})();
